export const findValue = (field) => {
    // gets the value of a field based on it's type
    let result = {
        value: null,
        prop: null,
    };
    const type = field.type;
    if (type === "numeric") {
        result.value = field.numericValue;
        result.prop = "numericValue";
    } else if (type === "date") {
        result.value = field.dateValue;
        result.prop = "dateValue";
    } else {
        result.value = field.textValue;
        result.prop = "textValue";
    }
    return result;
}